function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Algemeen/Selectbox_off",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Invisible_shape",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.6666667,2 L5.33333333,2 C3.48871111,2 2,3.48871111 2,5.33333333 L2,18.6666667 C2,20.5112889 3.48871111,22 5.33333333,22 L18.6666667,22 C20.5112889,22 22,20.5112889 22,18.6666667 L22,5.33333333 C22,3.48871111 20.5112889,2 18.6666667,2 Z M20,18.8571429 C20,19.4973257 19.4973257,20 18.8571429,20 L5.14285714,20 C4.50267429,20 4,19.4973257 4,18.8571429 L4,5.14285714 C4,4.50267429 4.50267429,4 5.14285714,4 L18.8571429,4 C19.4973257,4 20,4.50267429 20,5.14285714 L20,18.8571429 Z",
  id: "Fill-1",
  fill: "#DBDBDB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20,18.8571429 C20,19.4973257 19.4973257,20 18.8571429,20 L5.14285714,20 C4.50267429,20 4,19.4973257 4,18.8571429 L4,5.14285714 C4,4.50267429 4.50267429,4 5.14285714,4 L18.8571429,4 C19.4973257,4 20,4.50267429 20,5.14285714 L20,18.8571429 Z",
  id: "Path",
  fill: "#FFFFFF"
}));
function SvgSelectboxOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Algemeen/Selectbox_off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectboxOff);
export default __webpack_public_path__ + "static/media/Selectbox_off.1b8cd0aed42017a37b58f648b9483ed0.svg";
export { ForwardRef as ReactComponent };